import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const CustomBottomNavigation = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'none'
  },
  position: 'fixed',
  left: 0,
  bottom: 0,
  zIndex: 101,
  width: '100%',
  paddingBottom: 'env(safe-area-inset-bottom)',
  borderTop: `1px solid ${theme.r4r.greyLight}`,
  backgroundColor: '#fff',
  height: 'calc(57px + env(safe-area-inset-bottom))',
  '.MuiBottomNavigationAction-root': {
    color: '#666',
    minWidth: 'unset',
    '.MuiBottomNavigationAction-label': {
      fontSize: '10px',
      fontWeight: 500,
      '&.Mui-selected': {
        fontSize: '10px'
      }
    },
    '&.Mui-selected': {
      color: theme.r4r.navy
    }
  }
}))

export const CustomHeaderNavigation = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    width: '100%',
    left: 0
  },
  [theme.breakpoints.up('md')]: {
    display: 'none'
  },
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: 'calc(90px + env(safe-area-inset-top))',
  position: 'fixed',
  top: 0,
  paddingTop: 'env(safe-area-inset-top)',
  backgroundColor: theme.palette.background.default,
  zIndex: 100,
  width: '100%'
}))

interface DashboardContentProps {
  noHeader?: boolean
  disableGutters?: boolean
}

export const DashboardContent = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'noHeader' && prop !== 'disableGutters'
})<DashboardContentProps>(({ theme, noHeader, disableGutters }) => ({
  [theme.breakpoints.down('md')]: {
    paddingBottom: 'calc(57px + env(safe-area-inset-bottom))',
    paddingTop: noHeader ? 0 : '90px'
  },
  [theme.breakpoints.up('md')]: {
    // 56px navy top bar + 240px sidebar from the Figma layout.
    paddingLeft: disableGutters ? '240px' : '280px',
    paddingRight: disableGutters ? 0 : '40px',
    paddingTop: noHeader ? '56px' : '90px'
  }
}))
